
// [11.0.9] Девять привязок кнопок v10 ПЕРЕЕХАЛИ отсюда в модуль
// src/ui/newFeaturesBindings.js (функция initNewFeaturesButtons).
//
// Работали они и здесь, но были невидимы для поиска по src/: кто искал
// обработчик и не находил, делал вывод «кнопка мёртвая». В эту ловушку попадал
// и я при разборе верхнего меню — поиск показал «привязки не найдено» у
// «Фракции выброса» и «Атрофии мозга», хотя обе живые. Цена такой ошибки —
// удалённая клиническая функция.
//
// Здесь остаются только ВВОЗЫ модулей: их видно и так, а обработчиков в
// разметке больше нет ни одного.
import { initNewFeaturesButtons } from "./src/ui/newFeaturesBindings.js";
initNewFeaturesButtons();

// [10.19.9] Ниже раньше лежали ещё 50 строк кода — СНАРУЖИ этого тега, сырым
// текстом в <body>. Браузер их не исполнял: 24 кнопки не были привязаны ни к
// чему. Код перенесён в настоящий модуль, где его видят проверки.
import './src/ui/toolsBindings.js';
